import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { MapState } from "./types";
import { loadMap, saveMap } from "../../store/localStorage";

const initialState: MapState = {
  data: null,
  loading: false,
  error: null,
};

export const fetchMapDataAsync = createAsyncThunk(
  "map/fetchMapData",
  async (year: string) => {
    const map_api = loadMap();
    return map_api || (await api.getMap(year));
  }
);

const mapApiSlice = createSlice({
  name: "map",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMapDataAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMapDataAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        saveMap(action.payload);
      })
      .addCase(fetchMapDataAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch map data";
      });
  },
});

export default mapApiSlice.reducer;
